export const regionStore = state => state.regionStore
export const regionStores = state => state.regionStores
